import React, { useEffect, useState } from "react";
import StdReviewLogo from "../../Assets/images/New/student-review.jpg";

const StudentReviews = ({ rating }) => {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const containerStyles = {
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "8px",
        borderRadius: "8px",
        minWidth: isMobile ? "300px" : "150px",
        justifyContent: "space-between",
    };

    const ratingStyles = {
        fontSize: isMobile ? "20px" : "24px",
        fontWeight: "bold",
        color: "#333",
    };

    const logoImageStyles = {
        width: isMobile ? "180px" : "120px",
    };

    return (
        <div style={containerStyles}>
            <span style={styles.logo}>
                <img src={StdReviewLogo} alt="Sitejabber Logo" style={logoImageStyles} />
            </span>
            <span style={ratingStyles}>{rating}</span>
        </div>
    );
};

const styles = {
    logo: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "8px",
    },
};

export default StudentReviews;
